// AUTO-GENEROWANE przy starcie/buildzie (scripts/gen-build-info.js). Nie edytuj ręcznie.
export const BUILD_INFO = {"version":"1.9.17","builtAt":"2026-11-03T02:07:53.462Z"};
